import React from 'react';
import { Link } from 'react-router';

import './HomeView.scss';

export const HomeView = props => (
  <div className='WelcomeWrap'>
    {props.location.query.signup && (
      <div className='FlashMessage'>
        <p>Your account has been created - you can sign back in later anytime to access this dashboard using your LinkedIn account</p>
      </div>
    )}
    <h3>Quick Start</h3>
    <p>
      Congratulations and welcome to the Paragon One family. Using our proprietary matching system that marries the human element with data, our team is eager to pair you with a student to begin advising sessions. Please complete your profile now so we can begin to match you with students.
    </p>
    <Link to='/advisor/profile' className='Btn'>Complete My Profile</Link>

    <br />
    <h5>Advising Flowchart</h5>
    <img style={{ maxWidth: '100%' }} src="/images/AdvisingFlowChart.png" alt="Advising Flowchart" />

    <h5>Set Up Zoom</h5>
    <p>
      All of Paragon One sessions are conducted over the video software Zoom. When you have been matched with a student for a session, you will receive a Zoom link in the email calendar invite that will automatically start the software to begin your session.
    </p>
    <p>
      Here is the link to install Zoom: <a href="https://zoom.us/download">https://zoom.us/download</a>
    </p>
    <br />
    <Link to='/advisor/profile' className='Btn'>Complete My Profile</Link>
    <br />
    <p className='centerText'>
      Email <a href='mailto:byron@paragonone.com'>byron@paragonone.com</a><br />
      with any questions about the Advisor Signup process.
    </p>
  </div>
);

export default HomeView;



// WEBPACK FOOTER //
// ./src/routes/advisor/routes/Home/components/HomeView/index.js